<template>
  <card>
    <div class="card-header pt-0">
      <h4 class="title mt-0">
        Staff Recommendations
      </h4>
    </div>
    <el-table
      class="table"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      :data="staff"
    >
      <el-table-column
        label="Staff Member"
        prop="FullName"
        class-name="text-left"
        width="140px"
      />
      <el-table-column
        label="Role"
        class-name="text-left"
        width="120px"
      >
        <template slot-scope="props">
          <div v-html="renderPositions(props.row.Positions)" />
        </template>
      </el-table-column>
      <el-table-column
        label="Recommended"
        width="110"
        class-name="text-left"
      >
        <template>
          Scoutmaster<br>
          SPL<br>
          ASPL<br>
          ASM-Programs<br>
          Scribe<br>
          ASM-Logistics<br>
          Quartermaster<br>
          Cook<br>
          ASM-TG<br>
          Troop Guide<br>
          NYLT
        </template>
      </el-table-column>
      <el-table-column
        label="For Sure"
        width="80"
      >
        <template slot-scope="props">
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.ScoutmasterRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.SplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.AsplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.AsmpRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.ScribeRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.AsmlRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.QmRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.CookRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.AsmtgRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Forsure"
            v-model="props.row.TroopGuideRecommendation"
          ><br>
          <input
            type="checkbox"
            v-model="props.row.NyltRecommendation"
          >
        </template>
      </el-table-column>
      <el-table-column
        label="Likely"
        width="80"
      >
        <template slot-scope="props">
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.ScoutmasterRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.SplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.AsplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.AsmpRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.ScribeRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.AsmlRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.QmRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.CookRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.AsmtgRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Likely"
            v-model="props.row.TroopGuideRecommendation"
          >
        </template>
      </el-table-column>
      <el-table-column
        label="Maybe"
        width="80"
      >
        <template slot-scope="props">
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.ScoutmasterRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.SplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.AsplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.AsmpRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.ScribeRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.AsmlRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.QmRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.CookRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.AsmtgRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="Maybe"
            v-model="props.row.TroopGuideRecommendation"
          >
        </template>
      </el-table-column>
      <el-table-column
        label="Not Likely"
        width="80"
      >
        <template slot-scope="props">
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.ScoutmasterRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.SplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.AsplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.AsmpRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.ScribeRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.AsmlRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.QmRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.CookRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.AsmtgRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="NotLikely"
            v-model="props.row.TroopGuideRecommendation"
          >
        </template>
      </el-table-column>
      <el-table-column
        label="Previous"
        width="80"
      >
        <template slot-scope="props">
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.ScoutmasterRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.SplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.AsplRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.AsmpRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.ScribeRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.AsmlRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.QmRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.CookRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.AsmtgRecommendation"
          ><br>
          <input
            type="radio"
            class="ml-auto mr-auto"
            value="AlreadyServed"
            v-model="props.row.TroopGuideRecommendation"
          >
        </template>
      </el-table-column>
      <el-table-column label="Comments">
        <template slot-scope="props">
          <textarea
            class="form-control mb-1 mt-1"
            placeholder=""
            id="camping"
            style="max-height: 750px"
            v-model="props.row.RecommendationComments"
            :title="props.row.RecommendationComments"
            rows="11"
          />
          <button
            type="submit"
            class="btn btn-primary mb-1"
            @click="updateRow(props.row.Id)"
          >
            Update
          </button>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>

<script>
import recommendationApi from '@/services/api/recommendation.js'

export default {
  name: 'ReportCloseoutRecommendationsStaffEdit',
  data: function () {
    return {
      staff: [],
      cellStyle: {
        padding: '0',
        'font-size': '10px',
        'text-align': 'center',
        'vertical-align': 'baseline'
      },
      headerCellStyle: {
        padding: '0 0 0 0 !important',
        margin: '0',
        height: '20px',
        'font-size': '10px',
        'vertical-align': 'baseline',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      }
    }
  },
  mounted: function () {
    recommendationApi
      .getStaff(this.$root.courseKey)
      .then(x => {
        this.staff = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    renderPositions: function (cellValue) {
      return cellValue.replace(',', '<br/>')
    },
    getStaff: function (id) {
      let returnValue = null
      for (let i = 0; i < this.staff.length; i++) {
        if (this.staff[i].Id === id) {
          returnValue = this.staff[i]
          break
        }
      }
      return returnValue
    },
    updateRow: function (id) {
      const row = this.getStaff(id)

      if (row !== null) {
        recommendationApi
          .updateStaff(this.$root.courseKey, row)
          .then(x => {
            this.staff = x
            this.$notify({
              message: 'Update complete.',
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating your recommendation.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
